function formatDate(
    date: Date | string | null | undefined,
    locale: string | undefined = undefined,
    options: Intl.DateTimeFormatOptions | undefined = undefined,
): string {
    return date ? new Date(date).toLocaleDateString(locale, options) : '--';
}

function formatDateTime(date: Date | null | string): string {
    if (date == null) {
        return '--';
    }

    // Use default locale and options
    const dateTimeFormat = new Intl.DateTimeFormat();

    // Use resolvedOptions to get user's actual time zone
    const resolvedOptions = dateTimeFormat.resolvedOptions();
    const userTimeZone = resolvedOptions.timeZone;

    const dateOptions: Intl.DateTimeFormatOptions = {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        timeZone: userTimeZone,
    };

    const timeOptions: Intl.DateTimeFormatOptions = {
        hour: 'numeric',
        hour12: false,
        minute: 'numeric',
        timeZone: userTimeZone,
        timeZoneName: 'short',
    };

    const newDate = (date instanceof Date) ? date : new Date(date);

    // Gets rid of the comma between the year and the time
    return `${newDate.toLocaleDateString(undefined, dateOptions)}   ${newDate.toLocaleTimeString(undefined, timeOptions)}`;
}

export {
    formatDate,
    formatDateTime,
};
